var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M356.822 40.039c-72.6 0-131.665 59.071-131.665 131.678v20.139H71.786c-26.625 0-48.286 21.661-48.286 48.285v183.535c0 26.625 21.661 48.286 48.286 48.286h224.32c26.625 0 48.285-21.661 48.285-48.286V240.141c0-26.625-21.661-48.285-48.285-48.285h-15.163v-20.139c0-41.847 34.039-75.893 75.879-75.893s75.879 34.045 75.879 75.893v66.154a7.5 7.5 0 0 0 7.5 7.5H481a7.5 7.5 0 0 0 7.5-7.5v-66.154c0-72.608-59.071-131.678-131.678-131.678zm-27.431 200.102v183.535c0 18.354-14.932 33.286-33.285 33.286H71.786c-18.354 0-33.286-14.932-33.286-33.286V240.141c0-18.354 14.932-33.285 33.286-33.285h224.32c18.353 0 33.285 14.932 33.285 33.285zm144.109-9.77h-25.799v-58.654c0-50.118-40.768-90.893-90.879-90.893s-90.879 40.774-90.879 90.893v20.139h-25.786v-20.139c0-64.336 52.335-116.678 116.665-116.678 64.336 0 116.678 52.342 116.678 116.678zm-289.554 32.52c-22.501 0-40.808 18.307-40.808 40.808a40.805 40.805 0 0 0 14.501 31.193v58.535a7.5 7.5 0 0 0 7.5 7.5h37.613a7.5 7.5 0 0 0 7.5-7.5v-58.535a40.808 40.808 0 0 0 14.502-31.193c0-22.502-18.307-40.808-40.808-40.808zm14.566 62.11a7.496 7.496 0 0 0-3.26 6.186v54.739h-22.613v-54.739a7.496 7.496 0 0 0-3.26-6.186 25.826 25.826 0 0 1-11.242-21.303c0-14.23 11.578-25.808 25.808-25.808s25.808 11.578 25.808 25.808a25.823 25.823 0 0 1-11.241 21.303z",
    fill: "currentcolor",
    "data-original": "currentcolor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.d02050ed471930a7cfbdc642ac246c9c.svg";
export { ForwardRef as ReactComponent };